import React from 'react';
import './clientBox.css';

function ClientBoxTile({ title, statement, image, name, companyPosition }) {
  return (
    <div
     
      className="clientBox"
    >
      <img
        src={image}
        alt="Client"
        style={{
          height: '80px',
          width: '80px',
          borderRadius: '5em',
        }}
      />
      <div style={{ height: '32px' }} />
      <h3>{`${title}`}</h3> <div style={{ height: '32px' }} />
      <p>{`${statement}`}</p> <div style={{ height: '32px', }} />
      <h4>{`${name}`}</h4> <div style={{ height: '8px' }} />
      <h4 style={{ textAlign:'center'}}>{`${companyPosition}`}</h4>
    </div>
  );
}

export const ClientBox = () => {
  return (
    <div className="clientBoxSection">
      <ClientBoxTile
        title="One Of The Hardest Working Individuals"
        name={'Alexander Howard'}
        companyPosition="Founder & CEO, Wicked Maine Lobster"
        image="https://firebasestorage.googleapis.com/v0/b/aryash-dubey.appspot.com/o/209289868_187870273180366_305638107167754847_n.jpg?alt=media&token=963cf3a6-3838-41de-908d-e16c8fb7d64c"
        statement="Undoubtedly one of the hardest working individuals I have ever had the pleasure of working with. Aryash not only exemplifies how creative he can be, but he also provides excellent communication and shows attentiveness to his customers. I Alex Howard, Founder & CEO of Wicked Maine Lobster ™, highly recommend Aryash Dubey for all of your mobile app and website development needs."
      />
      <ClientBoxTile
        title="NYC now have a “GO-TO” App Developer"
        image="https://firebasestorage.googleapis.com/v0/b/appjox-fa46b.appspot.com/o/169866_193529793996232_193529187329626_839508_2452737_o_1297668525_1297668550.jpg?alt=media&token=a0bb9cd3-8633-4949-8dc0-fdd6fc6ea190"
        name={'Kobe Jamero'}
        companyPosition="Founder & CEO, Luxor Studios"
        statement="In a society where it's hard to find hardworking and dedicated individuals that live for their work and will work endlessly with your vision in mind, I’m personally honored to have worked with Aryash Dubey. We stayed up many nights working on this App. With that being said, If you’re in need of an App, and you’re thinking about which direction to go, please go with him. All Recording Artists in The City of New York now have “GO - TO” Application Creator. Trust my word, he's the best. Thanks for your consistency Sir."
      />
    </div>
  );
};
